import { workspaceReducer } from './workspace';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { segmentReducer } from './segment';
import { gridReducer } from './rulesGrid';
import { testCaseReducer } from './testCase';
import { settingReducer, settingSaga } from './setting';
import { segmentSaga } from './segment/saga';
import { workspaceSaga } from './workspace';
import { all } from 'redux-saga/effects';
import { gridSaga } from './rulesGrid';
import { testCaseSaga } from './testCase';
import { projectReducer, projectSaga } from './project';
import { dashboardReducer, dashboardSaga } from './dashboard';
import { authReducer, authSaga } from './auth';
import { accessReducer, accessSaga } from './access';
import { documentNodeReducer, documentNodeSaga } from './documentNode';
import { testReducer, testSaga } from './test';

const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
  combineReducers({
    dashboard: dashboardReducer,
    project: projectReducer,
    workspace: workspaceReducer,
    segment: segmentReducer,
    grid: gridReducer,
    testCase: testCaseReducer,
    setting: settingReducer,
    auth: authReducer,
    access: accessReducer,
    documentNode: documentNodeReducer,
    test: testReducer,
  }),
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);

export const runSagaMiddleware = () => {
  sagaMiddleware.run(rootSaga);
};

function* rootSaga() {
  yield all([
    ...dashboardSaga,
    ...projectSaga,
    ...segmentSaga,
    ...workspaceSaga,
    ...gridSaga,
    ...testCaseSaga,
    ...settingSaga,
    ...authSaga,
    ...accessSaga,
    ...documentNodeSaga,
    ...testSaga,
  ]);
}
